module.exports = __webpack_public_path__ + "img/oncasy_logo.46725fac.png";